import {
  Directive,
  Input,
  HostBinding,
  ElementRef,
  Renderer2
} from '@angular/core';


@Directive({
  selector: '[circleButton]',
  exportAs: 'circle-button'
})
export class CircleButtonDirective {

  @Input()
  set color(color: string) {
    this._setClassName(`color-${color}`);
  }

  @HostBinding('class.circle-btn') circleBtn: boolean = true;

  @HostBinding('class.btn-responsive')
  @Input() responsive: boolean = false;


  constructor(public elementRef: ElementRef, private renderer: Renderer2) { }

  private _setClassName(className: string) {
    this.renderer.addClass(this.elementRef.nativeElement, className);
  }

}
